import db from '../db.js';
import { stringify, parse } from '../misc.js';

// Type for Left<->Right selection fields
export default function (...args)	// store, target, { values: [], labels: [], index: 0 }
{
	return {

		events: ['move'],
		_store: args[0],									// DB store name (eg: 'companies')
		_target: args[1],									// Selector to the SELECT containing the list of available options
		_values: args[2]?.values || ['id'],					// List of properties that will become the <option value=""> (eg: ['id'])
		_labels: args[2]?.labels || ['name'],				// List of properties that will become the <option>label</option> (eg: ['name'])
		_index: args[2]?.index,								// Index to use when retrieving DB data (1 or 2)

		captureEvents(_this = this)
		{
			this.capture();
			this.safeProtoCall(_this);
		},

		getValue(default_value = '[]', _this = this)
		{
			return parse(this.safeProtoCall(default_value, _this)).map(entry => entry.length == 1 ? entry[0] : entry);
		},

		setValue(values, _this = this)
		{
			return this.safeProtoCall(stringify((values ?? []).map(entry => Array.isArray(entry) ? entry : [entry])), _this);
		},

		isEmpty(values = this.getValue())
		{
			return parse(values).length == 0;
		},

		async refresh()
		{
			let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
			if (!node)
				return;
			node.innerHTML = (await Promise.all(this.getValue().map(async key => 
			{
				return await this.makeOption(await db.get(this._store, key, this._index));
			}))).join('\n');
		},

		async makeOption(data)
		{
			if (!data)
				return;
			let value = stringify(this._values.map(entry => data[entry]));
			let label = this._labels.map(entry => data[entry]).join(' ');
			return `<option value="${value}">${label}</option>`;
		},

		handleEvents(ev)
		{
			this.setValue(Array.from(ev.target.children).map(option => parse(option.value)));
		},

		capture()
		{
			let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
			node.parentNode.nextElementSibling.querySelectorAll('button').forEach(button =>
			{
				button.addEventListener('click', this.move.bind(this));
			});
		},

		async fill()
		{
			let available = await db.list(this._store, undefined, this._index);										// Must be the first operation to give time for the form to set its values
			let selected = parse(this.form.getFieldBySelector(this.selector).getValue()).map(entry => String(entry));
			available = available.filter(entry => !selected.includes(String(this._values.map(key => entry[key]))));	// Remove currently selected options from the available list
			let options = await Promise.all((available ?? []).map(entry => this.makeOption(entry)));
			document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n');		// Join prevent commas from being automatically inserted by JS
		},

		move(ev)
		{
			let selected = document.querySelector(`${this?.form.selector} ${this.selector}`);
			let available = document.querySelector(`${this?.form.selector} ${this._target}`);
			switch (ev.target.className)
			{
				case 'bn_Left':
					Array.from(available.selectedOptions).forEach(option => selected.appendChild(option));
					break;
				case 'bn_Right':
					Array.from(selected.selectedOptions).forEach(option => available.appendChild(option));
					break;
			}
			selected.dispatchEvent(new CustomEvent('move'));
		},

	};
}

